import { render, staticRenderFns } from "./AboutUsPage.vue?vue&type=template&id=8a28013e&scoped=true"
import script from "./AboutUsPage.vue?vue&type=script&lang=js"
export * from "./AboutUsPage.vue?vue&type=script&lang=js"
import style0 from "./AboutUsPage.vue?vue&type=style&index=0&id=8a28013e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a28013e",
  null
  
)

export default component.exports